export default __webpack_public_path__ + "static/media/sticker-12.53e067a1.png";